import { Box } from '@mui/material';
import CommonEntityMetadata from './EntityMetadata';

const EntityMetadataAccordingToType = ({ editableEntityData, setEditableEntityData, artists, global_constant }) => {

    console.log("editableEntityData in EntityMetadataAccordingToType:", editableEntityData?.type);
    return (
        <Box sx={styles.containerStyleColumn_sx}>
            {editableEntityData?.type?.toLowerCase() === 'artist' && (
                <CommonEntityMetadata
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    artists={artists}
                    showLanguage={false}
                    showCountry={false}
                    platform={false}
                    showYear={false}
                    showReleased={false}
                    showDuration={false}
                    showLabel={false}
                    showPlot={false}
                    showMultiSelectDropdownWithImages={false}
                    showIndustry={false}
                    showArtistType={true}
                    showSuperStar={false}
                />
            )}

            {editableEntityData?.type?.toLowerCase() === 'movie' && (
                <CommonEntityMetadata
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    artists={artists}
                    showLanguage={false}
                    showCountry={false}
                    platform={false}
                    showYear={false}
                    showReleased={false}
                    showDuration={false}
                    showIndustry={false}
                    showLabel={false}
                    showPlot={true}
                    showArtistType={false}
                    showSuperStar={false}
                    showMultiSelectDropdownWithImages={true}
                />
            )}

            {editableEntityData?.type?.toLowerCase() === 'song' && (
                <CommonEntityMetadata
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    artists={artists}
                    showLanguage={false}
                    showCountry={false}
                    platform={false}
                    showYear={false}
                    showReleased={false}
                    showDuration={false}
                    showIndustry={false}
                    showLabel={false}
                    showPlot={false}
                    showArtistType={false}
                    showSuperStar={false}
                    showMultiSelectDropdownWithImages={true}
                />
            )}

             {editableEntityData?.type?.toLowerCase() === 'reel' && (
                <CommonEntityMetadata
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    artists={artists}
                    showLanguage={false}
                    showCountry={false}
                    platform={false}
                    showYear={false}
                    showReleased={false}
                    showDuration={false}
                    showIndustry={false}
                    showLabel={false}
                    showPlot={false}
                    showArtistType={false}
                    showSuperStar={false}
                    showMultiSelectDropdownWithImages={true}
                />
            )}

             {editableEntityData?.type?.toLowerCase() === 'video' && (
                <CommonEntityMetadata
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    artists={artists}
                    showLanguage={false}
                    showCountry={false}
                    platform={false}
                    showYear={false}
                    showReleased={false}
                    showDuration={false}
                    showIndustry={false}
                    showLabel={false}
                    showPlot={false}
                    showArtistType={false}
                    showSuperStar={false}
                    showMultiSelectDropdownWithImages={true}
                />
            )}

            {editableEntityData?.type?.toLowerCase() === 'influencers' && (
                <CommonEntityMetadata
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    artists={artists}
                    showLanguage={false}
                    showCountry={false}
                    platform={false}
                    showYear={false}
                    showReleased={false}
                    showDuration={false}
                    showIndustry={false}
                    showLabel={false}
                    showPlot={false}
                    showArtistType={false}
                    showSuperStar={false}
                    showMultiSelectDropdownWithImages={true}
                />
            )}
        </Box>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default EntityMetadataAccordingToType